import request from '@/utils/request'
/**
 * 保险公司列表
 */
export function listInsurance(para){
    return request({
        url:'/vehicleconfig/configInsurance/list',
        method:'post',
        data:para
    })
}

export function addInsurance(para){
    return request({
        url:'/vehicleconfig/configInsurance/add',
        method:'post',
        data:para
    })
}

export function updateInsurance(para){

    return request({
        url:'/vehicleconfig/configInsurance/edit',
        method:'post',
        data:para
    })
}
export function delInsurance(para){
    return request({
        url:'/vehicleconfig/configInsurance/remove',
        method:'post',
        data:para
    })
}